<template>
    <Wrapper>
        <a id="main-content" class="fixed top-0" tabindex="-1"></a>

        <Breadcrumb :items="breadcrumbItems" />

        <div class="grid grid-cols-12 base-responsive-gap mt-6">
            <div class="col-span-12 lg:col-span-7">
                <h1 class="header-1 mb-4"><T t="press.releases" /></h1>
                <p class="lead"><T t="press.lead" /></p>
            </div>
        </div>

        <div class="grid grid-cols-12 card-grid-responsive-gap xl:gap-y-14 mt-12">
            <div
                v-for="(release, i) in pressReleases"
                :key="`press-release-${i}`"
                class="col-span-12 sm:col-span-6 lg:col-span-4"
            >
                <PressReleaseCard
                    :slug="release.slug"
                    :title="release.name"
                    :description="release.lead_text"
                    :date="release.published_at || release.created_at"
                />
            </div>
        </div>

        <h2 class="header-1 mb-4 mt-16 lg:mt-20"><T t="media_library.title" /></h2>
        <div class="grid grid-cols-12 card-grid-responsive-gap xl:gap-y-14 mt-8 lg:mt-12">
            <div
                v-for="(galleryCategory, i) in galleryCategories"
                :key="`gallery-category-${i}`"
                class="col-span-12 md:col-span-6 lg:col-span-4"
            >
                <MediaLibraryCard
                    :img="galleryCategory.media.icon.sm"
                    :photo-count="galleryCategory.photo_count"
                    :slug="galleryCategory.slug"
                    :title="galleryCategory.title"
                />
            </div>
        </div>
    </Wrapper>
</template>

<script>
import Wrapper from '@/components/Pages/Docs/Wrapper.vue';
import PressReleaseCard from '@/components/Cards/PressReleaseCard/PressReleaseCard.vue';
import MediaLibraryCard from '@/components/Cards/MediaLibraryCard/MediaLibraryCard.vue';

export default {
    name: 'PressIndex',
    components: {
        Wrapper,
        PressReleaseCard,
        MediaLibraryCard,
    },
    async asyncData({ $axios, i18n, redirect, localePath }) {
        if (i18n.locale === 'en') {
            return await redirect(307, localePath('magazine'));
        }

        let pressReleases = [];
        let galleryCategories = [];

        await Promise.allSettled([$axios.$get('/presses'), $axios.$get('/gallery-categories')])
            .then(([pressesRes, galleryCategoriesRes]) => {
                if (pressesRes.status === 'fulfilled') {
                    pressReleases = pressesRes.value.data;
                }

                if (galleryCategoriesRes.status === 'fulfilled') {
                    galleryCategories = galleryCategoriesRes.value.data;
                }
            })
            .catch((err) => {
                console.log(err);
            });

        const breadcrumbItems = [];

        breadcrumbItems.push([i18n.t('press.title'), 'press']);

        return {
            breadcrumbItems,
            pressReleases,
            galleryCategories,
        };
    },
    head() {
        return {
            title: this.$getPageTitle('press.index'),
            meta: this.$getPageMetaData('press.index'),
        };
    },
};
</script>

<style scoped></style>
